import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import parse from "html-react-parser";
import { generalTerms } from "./constants";
import styles from "./LegalDocuments.module.scss";

const parsedGeneralTerms = generalTerms(styles).map((term) => ({
  ...term,
  content: parse(term.value),
}));

type Props = {
  defaultExpanded?: boolean;
};

export const TermsOfUse = ({ defaultExpanded = false }: Props) => {
  const [isTermsExpanded, setTermsExpanded] = useState(defaultExpanded);
  const handleTermsChange = () => setTermsExpanded((previous) => !previous);

  return (
    <Accordion
      expanded={isTermsExpanded}
      onChange={handleTermsChange}
      sx={{
        position: "relative",
        border: "1px solid #F3F3F3",
        borderRadius: "6px",
        "&:first-of-type": {
          borderRadius: "6px",
        },
      }}
      disableGutters
    >
      <AccordionSummary
        id="generalTerms"
        sx={{
          p: "17px 20px",
          ":after": {
            content: "''",
            position: "absolute",
            left: "20px",
            bottom: 0,
            height: "2px",
            width: "75px",
            bgcolor: isTermsExpanded ? "secondary.main" : "transparent",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          SeniorComps Terms of Use
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: "16px 20px", lineHeight: 0 }}>
        {parsedGeneralTerms.map((term) => {
          return (
            <Typography
              component={term.isHeading ? "h3" : "p"}
              sx={{
                "&.MuiTypography-root": {
                  fontSize: "14px",
                  lineHeight: 1.6,
                  mb: "20px",
                },
                ...term.style,
              }}
              key={term.value}
            >
              {term.content}
            </Typography>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};
